import { getCycleDocumentId, getFormCycle } from "@/app/form/[...slug]/form-cycles";

/**
 * Which form_responses the admin list shows for a form id (e.g. "fashion_designer").
 * Everything saved since January 1 of the current year, as before, plus every
 * response for the form's current cycle regardless of year. That keeps
 * cross-year cycles (the February 25, 2027 designer call opened in 2026)
 * visible after New Year without hiding anything that used to show.
 */
export function getAdminResponseWindow(formId: string, now: Date = new Date()) {
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const cycle = getFormCycle(formId.replaceAll("_", "/"));
  const cycleDocId = cycle ? getCycleDocumentId(cycle) : null;
  return {
    cycleDocId,
    /** Lower bound for the Firestore timestamp filter. */
    since: cycleDocId ? new Date(0) : startOfYear,
    include(docId: string, timestamp: Date | null): boolean {
      if (cycleDocId && docId === cycleDocId) return true;
      return !!timestamp && timestamp.getTime() >= startOfYear.getTime();
    },
  };
}
